import { render } from "./topicGoods.vue?vue&type=template&id=04c21bf0"
import script from "./topicGoods.vue?vue&type=script&lang=js"
export * from "./topicGoods.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__